import { createCall, spellbook } from "@sdk/spellbook";

import { withAccountOrNetworkAuthHeaders } from "./apiHelpers";

const endpoint = spellbook("/me/organisations/features-policy").GET();

export async function getFeaturesPolicy() {
    const call = createCall(endpoint, (r) => fetch(withAccountOrNetworkAuthHeaders(r)));
    return await call({});
}
